import { useState } from "react";
import Layout from "@/components/feature/Layout";

interface Sablon {
  id: number;
  baslik: string;
  icerik: string;
  kategori: string;
}

const defaultSablonlar: Sablon[] = [
  {
    id: 1,
    baslik: "Ödeme Hatırlatma",
    kategori: "Alacak",
    icerik:
      "Merhaba, kuyum alışverişinizle ilgili kalan ödemenizin tarihi yaklaşmıştır. Müsait olduğunuzda bizimle iletişime geçmenizi rica ederiz.",
  },
  {
    id: 2,
    baslik: "Geciken Ödeme",
    kategori: "Alacak",
    icerik:
      "Merhaba, kuyum alışverişinizle ilgili ödemeniz gecikmiştir. En kısa sürede ödeme yapmanızı rica ederiz. Teşekkürler.",
  },
  {
    id: 3,
    baslik: "Sipariş Hazır",
    kategori: "Sipariş",
    icerik:
      "Merhaba, siparişiniz hazır hale gelmiştir. Teslim almak için dükkanımıza bekleriz.",
  },
  {
    id: 4,
    baslik: "Teslim Hatırlatma",
    kategori: "Sipariş",
    icerik:
      "Merhaba, siparişiniz teslim tarihi yaklaşmıştır. Detaylar için bizimle iletişime geçebilirsiniz.",
  },
  {
    id: 5,
    baslik: "Kapora Hatırlatma",
    kategori: "Alacak",
    icerik:
      "Merhaba, siparişiniz için kapora ödemenizi hatırlatmak isteriz. Kapora alındıktan sonra üretim başlayacaktır.",
  },
];

export default function MesajSablonlari() {
  const [sablonlar, setSablonlar] = useState<Sablon[]>(defaultSablonlar);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [kategoriFilter, setKategoriFilter] = useState("Tümü");
  const [copyToast, setCopyToast] = useState<string | null>(null);

  const filtered = sablonlar.filter(
    (s) => kategoriFilter === "Tümü" || s.kategori === kategoriFilter
  );

  const handleAdd = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const fd = new FormData(form);
    const yeni: Sablon = {
      id: Date.now(),
      baslik: String(fd.get("baslik") || ""),
      kategori: String(fd.get("kategori") || "Alacak"),
      icerik: String(fd.get("icerik") || ""),
    };
    setSablonlar((prev) => [yeni, ...prev]);
    setShowAddForm(false);
    form.reset();
  };

  const handleEdit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!editingId) return;
    const form = e.currentTarget as HTMLFormElement;
    const fd = new FormData(form);
    setSablonlar((prev) =>
      prev.map((item) =>
        item.id === editingId
          ? {
              ...item,
              baslik: String(fd.get("baslik") || ""),
              kategori: String(fd.get("kategori") || ""),
              icerik: String(fd.get("icerik") || ""),
            }
          : item
      )
    );
    setEditingId(null);
    form.reset();
  };

  const handleDelete = (id: number) => {
    setSablonlar((prev) => prev.filter((item) => item.id !== id));
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopyToast("Kopyalandı!");
    setTimeout(() => setCopyToast(null), 2000);
  };

  const editRecord = sablonlar.find((d) => d.id === editingId);

  const kategoriler = ["Tümü", "Alacak", "Sipariş", "Genel"];

  return (
    <Layout>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-100 mb-1">
          Mesaj Şablonları
        </h1>
        <p className="text-sm text-gray-500">
          WhatsApp mesajlarınız için hazır şablonlar oluşturun ve yönetin.
        </p>
      </div>

      {/* Controls */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
        <div className="flex items-center gap-2">
          {kategoriler.map((k) => (
            <button
              key={k}
              onClick={() => setKategoriFilter(k)}
              className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-all cursor-pointer ${
                kategoriFilter === k
                  ? "bg-gold-500/10 text-gold-400 border border-gold-500/20"
                  : "bg-white/5 text-gray-400 border border-transparent hover:bg-white/10"
              }`}
            >
              {k}
            </button>
          ))}
        </div>
        <button onClick={() => setShowAddForm(true)} className="btn-gold">
          <i className="ri-add-line" />
          Yeni Şablon
        </button>
      </div>

      {/* Templates Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {filtered.map((s) => (
          <div key={s.id} className="glass-card p-4 flex flex-col">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h4 className="text-sm font-medium text-gray-200">{s.baslik}</h4>
                <span className="text-[10px] text-gray-500 bg-white/5 px-2 py-0.5 rounded-full mt-1 inline-block">
                  {s.kategori}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => handleCopy(s.icerik)}
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:bg-white/10 transition-colors cursor-pointer"
                  title="Kopyala"
                >
                  <i className="ri-file-copy-line text-xs" />
                </button>
                <button
                  onClick={() => setEditingId(s.id)}
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:bg-white/10 transition-colors cursor-pointer"
                  title="Düzenle"
                >
                  <i className="ri-edit-line text-xs" />
                </button>
                <button
                  onClick={() => handleDelete(s.id)}
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:bg-red-500/10 hover:text-red-400 transition-colors cursor-pointer"
                  title="Sil"
                >
                  <i className="ri-delete-bin-line text-xs" />
                </button>
              </div>
            </div>
            <div className="flex-1 bg-white/5 rounded-lg p-3 mb-3">
              <p className="text-xs text-gray-400 leading-relaxed">{s.icerik}</p>
            </div>
            <div className="text-right">
              <span className="text-[10px] text-gray-600">{s.icerik.length} karakter</span>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="p-8 text-center text-gray-500 text-sm">
          Şablon bulunamadı.
        </div>
      )}

      {/* Copy Toast */}
      {copyToast && (
        <div className="fixed bottom-6 right-6 z-50 bg-gold-500/20 border border-gold-500/30 text-gold-400 text-sm px-4 py-2.5 rounded-lg backdrop-blur-md">
          {copyToast}
        </div>
      )}

      {/* Add Modal */}
      {showAddForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="glass-card w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-4 border-b border-white/5">
              <h3 className="text-lg font-semibold text-gray-100">Yeni Şablon Ekle</h3>
              <button onClick={() => setShowAddForm(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-200 cursor-pointer">
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <form onSubmit={handleAdd} className="p-4 space-y-4">
              <div>
                <label className="block text-xs text-gray-500 mb-1.5">Başlık</label>
                <input name="baslik" required className="input-dark w-full" placeholder="Şablon başlığı" />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1.5">Kategori</label>
                <select name="kategori" className="input-dark w-full" defaultValue="Alacak">
                  {kategoriler.slice(1).map((k) => (
                    <option key={k} value={k} className="bg-dark-950">{k}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1.5">Mesaj İçeriği</label>
                <textarea name="icerik" rows={5} required maxLength={500} className="input-dark w-full resize-none" placeholder="Mesaj içeriğini yazın..." />
                <p className="text-[10px] text-gray-600 mt-1">Maksimum 500 karakter</p>
              </div>
              <div className="flex items-center justify-end gap-3 pt-2">
                <button type="button" onClick={() => setShowAddForm(false)} className="btn-dark">İptal</button>
                <button type="submit" className="btn-gold">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editingId && editRecord && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="glass-card w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-4 border-b border-white/5">
              <h3 className="text-lg font-semibold text-gray-100">Şablon Düzenle</h3>
              <button onClick={() => setEditingId(null)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-200 cursor-pointer">
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <form onSubmit={handleEdit} className="p-4 space-y-4">
              <div>
                <label className="block text-xs text-gray-500 mb-1.5">Başlık</label>
                <input name="baslik" defaultValue={editRecord.baslik} required className="input-dark w-full" />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1.5">Kategori</label>
                <select name="kategori" className="input-dark w-full" defaultValue={editRecord.kategori}>
                  {kategoriler.slice(1).map((k) => (
                    <option key={k} value={k} className="bg-dark-950">{k}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1.5">Mesaj İçeriği</label>
                <textarea name="icerik" rows={5} defaultValue={editRecord.icerik} required maxLength={500} className="input-dark w-full resize-none" />
                <p className="text-[10px] text-gray-600 mt-1">Maksimum 500 karakter</p>
              </div>
              <div className="flex items-center justify-end gap-3 pt-2">
                <button type="button" onClick={() => setEditingId(null)} className="btn-dark">İptal</button>
                <button type="submit" className="btn-gold">Güncelle</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}